import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AuthService } from './../../shared/models/auth.service';
import { CompanyModel } from "./../../company/models/company.model";
import { DataListModel } from '../../shared/config';
import { CompanyService } from "../../company/models/company.service";
import { Observable } from 'rxjs/Observable';

@Component({
  selector: "wego-company-popup",
  template: require('../views/terms-condition-company-popup.component.html'),
  providers: [
    CompanyService
  ]
})

export class CompanyPopupComponent implements OnInit {
  instanceHashId: string;
  DataListModel: DataListModel;
  isParentCheck: boolean = false;
  companyList: CompanyModel[];
  SelectedList: string[] = [];
  SelectedNames: string[] = [];
  isLoading: boolean;
  apiErrorMsg: string;
  LblIcon: string = "fa fa-plus-square";

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('companyModal') public companyModal: any;

  constructor(
    private companyService: CompanyService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["companyName", "instanceName"];
  }

  public show(SelectedList: string[], SelectedNamesList: string[], instanceHashId: string): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNamesList;
    this.instanceHashId = instanceHashId;
    this.GetCompanyListByInstanceId();
    this.companyModal.show();
  }

  public OnParentCheck(isChecked: boolean) {
    this.companyList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.companyMasterHashId) == -1) {
          this.SelectedList.push(x.companyMasterHashId);
        }
        if (this.SelectedNames.indexOf(x.companyName) == -1) {
          this.SelectedNames.push(x.companyName);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(y => y != x.companyMasterHashId);
        this.SelectedNames = this.SelectedNames.filter(y => y != x.companyName);
      }
    });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetCompanyListByInstanceId();
  }

  private GetCompanyListByInstanceId() {
    this.isLoading = true;
    this.companyService.GetCompanybyInstanceHashId(this.DataListModel, this.instanceHashId)
      .subscribe(
      res => {
        this.companyList = res.data;
        this.companyList.forEach(x => x.isChecked =
          (this.SelectedList.indexOf(x.companyMasterHashId) > -1)
        );
        this.isParentCheck = this.companyList.every(x => x.isChecked);
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private ItemCheckChanged(companyMasterHashId: string, companyName: string, isChecked: any) {
    if (isChecked) {
      if (this.SelectedList.indexOf(companyMasterHashId) == -1) {
        this.SelectedList.push(companyMasterHashId);
      }
      if (this.SelectedNames.indexOf(companyName) == -1) {
        this.SelectedNames.push(companyName);
      }
      this.isParentCheck = this.companyList.filter(x => x.companyMasterHashId != companyMasterHashId).every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != companyMasterHashId);
      this.SelectedNames = this.SelectedNames.filter(x => x != companyName);
      this.isParentCheck = false;
    }
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetCompanyListByInstanceId();
  };

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetCompanyListByInstanceId();
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetCompanyListByInstanceId();
  }

  public hide(): void {
    this.companyModal.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;

    this.onSuccessSelect.emit({ CompanyHashId: this.SelectedList, CompanyName: this.SelectedNames });
    this.isLoading = false;
    this.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/components/terms-condition-company-popup.component.ts